//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Color from 'color';
import { Chrome } from 'vue-color';
import DpDropdown from '../dropdown/Dropdown.vue';
import DpInput from '../input/Input.vue';

export default {
  name: 'DpColour',
  components: {
    'chrome-picker': Chrome,
    DpDropdown,
    DpInput,
  },
  props: {
    placeholder: { type: String, default: '' },
    value: { type: String, default: null },
    displayAsRgb: { type: Boolean, default: false },
  },
  data() {
    return {
      colours: {
        hex: '#000000',
      },
      colourValue: '',
      displayPicker: false,
      supressNext: false, // FIXME: hack used to prevent double update from v-model
    };
  },
  watch: {
    colourValue(val, old) {
      if (val) {
        this.updatecolours(val);
      } else {
        this.colours = '#000';
        this.colourValue = null;
      }
      if (this.supressNext) {
        this.supressNext = false;
        return;
      }
      if (val !== old && old !== null && old !== '') {
        this.$emit('input', val);
        this.$emit('change', val);
      }
    },
    value(val) {
      this.supressNext = true;
      this.setColour(val);
    },
  },
  mounted() {
    this.setColour(this.value);
  },
  methods: {
    setColour(colour) {
      if (!colour) {
        return;
      }
      this.updatecolours(colour);
      this.colourValue = colour;
    },
    updatecolours(colour) {
      if (colour.slice(0, 1) === '#') {
        this.colours = {
          hex: colour,
        };
      } else if (colour.slice(0, 4) === 'rgba') {
        const rgbaColour = Color(colour);
        const hex = rgbaColour.hex().string();
        this.colours = {
          hex,
        };
      }
    },
    showPicker() {
      this.displayPicker = true;
    },
    hidePicker() {
      this.displayPicker = false;
    },
    togglePicker() {
      if (this.displayPicker) {
        this.hidePicker();
      } else {
        this.showPicker();
      }
    },
    updateFromInput() {
      this.updatecolours(this.colourValue);
    },
    updateFromPicker(colour) {
      this.colours = colour;
      if (!this.displayAsRgb) {
        this.colourValue = colour.hex;
      } else {
        this.colourValue = `rgb(${colour.rgba.r}, ${colour.rgba.g}, ${colour.rgba.b})`;
      }
    },
  },
};
